import { render, staticRenderFns } from "./IconKitchen.vue?vue&type=template&id=286218cc&"
import script from "./IconKitchen.vue?vue&type=script&lang=js&"
export * from "./IconKitchen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports